__webpack_require__.p = "https://cdn.medprev.online/web-app/assets/72f7f079/_next/";